import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export function PauseIcon({ color, ...svgProps }: Props) {
  return (
    <SVG
      ref={svgProps.ref}
      viewBox="0 0 15 18"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 18)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="4.5" height="16.5" x=".75" y=".75" rx="1.5" />
      <rect width="4.5" height="16.5" x="9.75" y=".75" rx="1.5" />
    </SVG>
  );
}
